import _ from 'lodash'

const combine = (...actionFns) => (action, prevState, nextState) => {
    return _.compact(_.flatten(_.map(actionFns, (fn) => fn(action, prevState, nextState))))
}

const pageView = (action, prevState, nextState) => ({
    hitType: 'pageview',
    page: nextState.quotation.viewState,
})

const clickOnBtnStartQuotation = (action) => {
    if (action.origin === 'FORM_INITIAL_BTN_DEMARRER') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-start-landscape',
            eventLabel: 'Clic sur le bouton "Démarrer"',
        }
    }
    return null
}

const clickOnBtnBypassConsumption = (action) => {
    if (action.origin === 'FORM_INITIAL_BTN_BYPASS') {
        return {
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-link-bypass-consumption',
            eventLabel: 'Clic sur le lien "Cliquez ici pour passer cette étape"',
        }
    }
    return null
}

const clickOnIconQuestionMarkLandscape = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-questionmark-landscape',
    eventLabel: 'Clic sur le "Questionmark - Paysage"',
})

const onLandscapeSuccess = (action) => {
    if (action.isLandscapeDone) {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'landscape-success',
            eventLabel: 'Paysage = success',
        })
    }
    return null
}

const onIneligibilityPostcode = (action, prevState, nextState) => {
    if (nextState.quotation.consumptionView.isPostCodeIneligible) {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'ineligibility-postcode',
            eventLabel: `Inéligibilité Code Postale ${nextState.quotation.consumptionView.consumptionForm.postcode}`,
        })
    }
    return null
}

const clickOnIconQuestionMarkWhereToFind = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-questionmark-wheretofind',
    eventLabel: 'Clic sur le "Questionmark - Où trouver ces informations ?"',
})

const onChoosePowerSelected = (action, prevState, nextState) => {
    const power = {
        previous: prevState.quotation.consumptionView.consumptionForm.power,
        current: nextState.quotation.consumptionView.consumptionForm.power,
    }
    if (power.previous !== power.current) {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'choosen-power',
            eventLabel: `Puissance choisie ${power.current}`,
            eventValue: power.current,
        })
    }
    return null
}

const clickOnEstimate = (action) => {
    if (action.origin === 'FORM_INITIAL_BTN_ESTIMATE_QUOTATION') {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-estimate',
            eventLabel: 'Clic sur le bouton "Estimer mon devis"',
        })
    }
    return null
}

const clickOnTimetable = (action) => {
    if (action.origin === 'RESULT_ANNUAL_CONSUMPTION_BTN_TIMETABLE') {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-see-timetable',
            eventLabel: 'Clic sur le bouton "Voir le détail"',
        })
    }
    return null
}

const clickOnTimetableExplanation = (action, prevState, nextState) => {
    const tutorial = nextState.quotation.timetableView.tutorial
    const tutorialState = tutorial.display ? tutorial.state : 'initial'
    return ({
        hitType: 'event',
        eventCategory: 'Quotation',
        eventAction: `clic-button-explanation-${tutorialState}`,
        eventLabel: `Clic sur le bouton tutorial ${tutorialState}`,
    })
}

const clickOnTimetableUnderstood = (action) => {
    if (action.origin === 'TIMETABLE_BTN_UNDERSTOOD') {
        return ({
            hitType: 'event',
            eventCategory: 'Quotation',
            eventAction: 'clic-button-understood',
            eventLabel: 'Clic sur le bouton "J’AI COMPRIS"',
        })
    }
    return null
}

const clickOnTimetableSleek = (action, prevState, nextState) => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'choosen-timetable-sleek',
    eventLabel: `Choix  "lisser" ${action.sleek_timetable}`,
    eventValue: action.sleek_timetable ? 1 : 0,
})

const clickOnPotChoosenSaving = (action, prevState, nextState) => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'choosen-savings',
    eventLabel: `Choix ${action.factorCons}`,
    eventValue: action.factorCons,
})

const hoverOnPotCardBill = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'hover-card-bill',
    eventLabel: 'Hover card "Ma facture annuelle baisse"',
})

const hoverOnPotCardPot = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'hover-card-bill',
    eventLabel: 'Hover card "Ma facture annuelle baisse"',
})

const clickOnButtonModifyInfo = (action) => {
    if (action.origin === 'RESULT_LANDSCAPE_BTN_MODIFY') {
        return ({
            hitType: 'event',
            eventCategory: 'quotation',
            eventAction: 'clic-button-modify-info',
            eventLabel: 'Clic sur le bouton "Modifier"',
        })
    }
    return null
}

const clickOnWhatIsIt = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-button-whatisit',
    eventLabel: 'Clic sur le bouton "Qu’est-ce que c’est"',
})

const clickOnVisitor = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-button-visitor',
    eventLabel: 'Clic sur le bouton "En simple visite ?"',
})

const clickOnSubscribePlum = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-button-goplum',
    eventLabel: 'Clic sur le bouton "Je passe chez Plüm"',
})

const clickOnDisplayNewsletterForm = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-visitor-newsletter-display-form',
    eventLabel: 'Clic sur le bouton pour afficher le formulaire de newsletter',
})

const clickOnSubmitNewsletterForm = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-visitor-newsletter-submit-form',
    eventLabel: 'Clic sur le bouton pour soumettre le formulaire de newsletter',
})

const clickOnDisplayFirstAdvice = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-visitor-newsletter-display-first-advise',
    eventLabel: 'Clic sur le bouton pour afficher premier conseil',
})

const clickOnVisitorFacebook = () => ({
    hitType: 'event',
    eventCategory: 'Quotation',
    eventAction: 'clic-link-facebook',
    eventLabel: 'Clic sur le lien "Facebook"',
})

const eventsMap = {
    GO_TO_INITIAL: pageView,
    GO_TO_FORM_LANDSCAPE: combine(pageView, clickOnBtnStartQuotation),
    GO_TO_FORM_CONSUMPTION: combine(pageView, clickOnBtnBypassConsumption, clickOnButtonModifyInfo),
    GO_TO_STATE_RESULT: combine(pageView, clickOnTimetableUnderstood),
    GO_TO_STATE_TIMETABLE: combine(pageView, clickOnTimetable),
    GO_TO_STATE_VISITOR: clickOnVisitor,
    GO_TO_STATE_POT: pageView,
    INIT_VIEW_STATE: pageView,
    VALIDATE_POST_CODE_DONE: onIneligibilityPostcode,
    UPDATE_FORM_CONSUMPTION: onChoosePowerSelected,
    GET_QUOTATION: combine(pageView, clickOnEstimate),
    GET_QUOTATION_DONE: pageView,
    GET_QUOTATION_ERROR: pageView,
    UPDATE_QUOTATION_POT: clickOnPotChoosenSaving,
    UPDATE_SLEEK_TIMETABLE: clickOnTimetableSleek,
    TIMETABLE_VIEW_TUTORIAL_CLOSE: clickOnTimetableExplanation,
    TIMETABLE_VIEW_TUTORIAL_NEXT: clickOnTimetableExplanation,
    LANDSCAPE_DONE: onLandscapeSuccess,
    DISPLAY_NEWSLETTER_FORM: clickOnDisplayNewsletterForm,
    SUBMIT_NEWSLETTER_FORM: clickOnSubmitNewsletterForm,
    DISPLAY_FIRST_ADVICE: clickOnDisplayFirstAdvice,
    CLICK_ON_QUESTION_MARK_FORM_INITIAL: clickOnIconQuestionMarkLandscape,
    CLICK_ON_QUESTION_MARK_FORM_CONSUMPTION: clickOnIconQuestionMarkWhereToFind,
    CLICK_ON_QUESTION_MARK_WHAT_IS_IT: clickOnWhatIsIt,
    CLICK_ON_SUBSCRIBE_PLUM: clickOnSubscribePlum,
    CLICK_ON_VISITOR_FACEBOOK: clickOnVisitorFacebook,
    HOVER_ON_CARD_BILL: hoverOnPotCardBill,
    HOVER_ON_CARD_POT: hoverOnPotCardPot,
}

export default eventsMap



// WEBPACK FOOTER //
// ./src/states/quotation/quotation.googleevents.js